import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  TemplateRef,
  ViewEncapsulation,
  contentChild,
  input,
} from '@angular/core';
import { Observable } from 'rxjs';
import { SimpleYesNoFooterComponent } from './footer/simple-yes-no-footer.component';
import { SimpleYesNoHeaderComponent } from './header/simple-yes-no-header.component';

@Component({
  selector: 'prime-simple-yes-no-modal',
  templateUrl: './simple-yes-no-modal.component.html',

  encapsulation: ViewEncapsulation.None,
  imports: [SimpleYesNoHeaderComponent, NgTemplateOutlet, SimpleYesNoFooterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleYesNoModalComponent {
  readonly headerLabel = input<string>();
  readonly cancelButtonLabel = input<string>();
  readonly confirmButtonLabel = input<string>();
  readonly closeOnCancel = input<boolean>(true);
  readonly confirmButtonDisabledStreamManager = input<Observable<boolean>>();
  readonly justifyPosition = input<'start' | 'end' | 'between'>('end');

  readonly header = contentChild<TemplateRef<any> | null>('header');
  readonly content = contentChild<TemplateRef<any> | null>('content');
  readonly footer = contentChild<TemplateRef<any> | null>('footer');

  @Output() onCancel: EventEmitter<void>;
  @Output() onConfirm: EventEmitter<void>;

  constructor() {
    this.onCancel = new EventEmitter<void>();
    this.onConfirm = new EventEmitter<void>();
  }

  cancelHandler(): void {
    this.onCancel.emit(undefined);
  }

  confirmHandler() {
    this.onConfirm.emit(undefined);
  }
}
